<template>
    <footer class="bg-black">
        <div class="container-fluid py-3">
            <div class="row px-3 px-lg-5 text-white py-5">
                <div class="col-md-4">
                    <div class="d-block h5 font-weight-bold mb-1">Reservas Alojamiento</div>
                    <a class="d-block" href="mailto:reservas@laparva.cl">reservas@laparva.cl</a>
                    <a class="d-block" href="https://wa.me/56992185396">WhatsApp +56 9 9218 5396</a>

                    <div class="d-block h5 font-weight-bold mb-1 mt-3">Reservas Ski Day</div>
                    <a class="d-block" href="mailto:skiday@laparva.cl">skiday@laparva.cl</a>
                    <a class="d-block" href="https://wa.me/56994029883">WhatsApp +56 9 9402 9883</a>

                    <div class="d-block h5 font-weight-bold mb-1 mt-3">Eventos y Activaciones</div>
                    <a class="d-block" href="mailto:jgonzalez@laparva.cl">jgonzalez@laparva.cl</a>
                    <a class="d-block" href="https://wa.me/56952351448">WhatsApp +56 9 5235 1448</a>
                </div>

                <div class="col-md-4">

                    <div class="d-block h5 font-weight-bold mb-1">Servicio al Cliente</div>
                    <a class="d-block" href="mailto:servicioalcliente@laparva.cl">servicioalcliente@laparva.cl</a>
                    <a class="d-block" href="https://wa.me/56939214656">WhatsApp +56 9 3921 4656</a>

                    <div class="d-block h5 font-weight-bold mb-1 mt-3">Escuela de Ski & Snowboard</div>
                    <a class="d-block" href="mailto:escuela@laparva.cl">escuela@laparva.cl</a>
                    <a class="d-block" href="https://wa.me/56966762030">WhatsApp +56 9 6676 2030</a>

                    <div class="d-block h5 font-weight-bold mb-1 mt-3">Contacto de Prensa & marketing</div>
                    <a class="d-block" href="mailto:marketing@laparva.cl">marketing@laparva.cl</a>
                    <a class="d-block" href="https://wa.me/56952351448">WhatsApp +56 9 5235 1448</a>
                </div>

                <div class="col-md-4">
                    <div class="d-block h5 font-weight-bold mb-1">Políticas de compra ticket FIX</div>
                    <a class="d-block text-muted" href="#">Políticas de compra ticket FIX</a>
                    <a class="d-block text-muted" href="#">Políticas de compra ticket FLEX</a>
                    <a class="d-block text-muted" href="#">Políticas de compra Pases y Cuponeras</a>
                    <a class="d-block mb-3" href="/faq">Preguntas frecuentes</a>


                    <a target="_blank" href="https://www.facebook.com/skilaparva" class="btn-rss rounded-circle mr-1">
                        <img src="~__STATIC__/img_link/facebook.svg" class="img-fluid img-rss" alt="">
                    </a>
                    <a target="_blank" href="https://instagram.com/skilaparva" class="btn-rss rounded-circle">
                        <img src="~__STATIC__/img_link/instagram.svg" class="img-fluid img-rss" alt="">
                    </a>
                </div>
            </div>
            <div class="row px-3 px-lg-5 py-3">
                <div class="col-12 border-line"></div>
                <div class="col-12 text-white mt-3">
                    <p>Copyright ©2025 - <a href="https://laparva.cl" target="_blank">laparva.cl</a></p>
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
import cartMixin from '../mixins/cartMixin';
import siteConfig from '../mixins/siteConfig';

export default {
    mixins: [cartMixin, siteConfig],

    props: {
        hasStickyFooter: {
            type: Boolean,
            default() {
                return false;
            }
        },
        cardType: {
            type: Object,
            default() {
                return {};
            }
        }
    },

    computed: {
        applySticketFooter() {
            if (window.location.pathname === this.getUrl('homeUrl') && this.count) {
                return true;
            }

            return this.hasStickyFooter;
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/Footer.vue